import { IconCalendar, IconWhatsApp } from '../../componentes/Icons';
import './Fidelizacao.css';

const FidelizacaoSection = ({ ghostClients, shopName }) => {
    return (
        <div className="section-fidelizacao fade-in">
            <div className="section-header-row">
                <div className="title-group">
                    <h2 className="section-main-title">Lembretes de Retorno</h2>
                    <p className="section-subtitle">Clientes que não aparecem há mais de 25 dias</p>
                </div>
                <div className="retention-count">
                    <span>{ghostClients.length}</span> Clientes Detectados
                </div>
            </div>

            <div className="admin-grid-layout full-width">
                <div className="admin-card">
                    <div className="ghost-clients-list">
                        {ghostClients.length > 0 ? (
                            ghostClients.map((client, idx) => (
                                <div key={idx} className="ghost-client-item">
                                    <div className="client-main-info">
                                        <div className="client-avatar-placeholder">
                                            {client.name.charAt(0).toUpperCase()}
                                        </div>
                                        <div className="client-text">
                                            <span className="client-name">{client.name}</span>
                                            <span className="client-last-service">Último: {client.lastService}</span>
                                        </div>
                                    </div>
                                    <div className="client-retention-stats">
                                        <div className="stat-pill warning">
                                            <IconCalendar /> {client.daysSinceLastVisit} dias ausente
                                        </div>
                                        <div className="stat-pill muted">
                                            Visto em: {client.date.toLocaleDateString('pt-BR')}
                                        </div>
                                    </div>
                                    <div className="client-actions">
                                        <button
                                            className="whatsapp-btn-retention"
                                            onClick={() => {
                                                const msg = `Olá ${client.name}! Tudo bem? Faz ${client.daysSinceLastVisit} dias que você não passa aqui na **${shopName}**. Estava olhando a agenda e lembrei de você. Que tal agendar um horário para renovar o visual? ✂️`;
                                                const link = `https://wa.me/${client.whatsapp.replace(/\D/g, '')}?text=${encodeURIComponent(msg)}`;
                                                window.open(link, '_blank');
                                            }}
                                            disabled={!client.whatsapp}
                                        >
                                            <IconWhatsApp /> Mandar Mensagem
                                        </button>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <div className="empty-state">
                                <div className="empty-icon">✅</div>
                                <h4>Agenda em Dia!</h4>
                                <p>Todos os seus clientes retornaram recentemente ou já têm novos agendamentos.</p>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FidelizacaoSection;
